import { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useSelector } from "react-redux";
import { PageVisit } from "../../Utility/API";
import "./about.css";

const AboutUs = () => {
  const state = useSelector((state) => state);

  useEffect(() => {
    PageVisit(state?.auth?.user?.idUser || "", "about-us");
  }, []);

  return (
    <div>
      <Helmet>
        <title>About us | BettDraft Fantasy Sports</title>
        <meta name="description" content="Learn about BettDraft Daily Fantasy Sports stats, house rules, payouts multiplier and more." />
        <link rel="canonical" href="https://dfs.bettdraft.com/about-us" />
        <meta property="og:title" content="About us | BettDraft Fantasy Sports" />
        <meta property="og:description" content="Learn about BettDraft Daily Fantasy Sports stats, house rules, payouts multiplier and more." />
        <meta property="og:url" content="https://dfs.bettdraft.com/about-us" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="About us | BettDraft Fantasy Sports" />
        <meta name="twitter:description" content="Learn about BettDraft Daily Fantasy Sports stats, house rules, payouts multiplier and more." />
      </Helmet>

      <div className="container bg-color-about space-bottom">
        <div className="inner-smallspace-about">
          <div className="row">
            <div className="col-md-12">
              <div className="content-page-design">
                <h2>About Us</h2>
                <p>
                  BettDraft is all about creating that winning experience.
                  Whether it’s about hitting that huge cash prize or just about
                  the bragging rights. BettDraft was created to build and drive
                  that spirit. Our mission is to make sure you have more ways to
                  win, more ways to play and that you have an entertaining
                  experience.
                </p>

                <h2>Our Vision</h2>

                <p>
                  BettDraft and every member of our team is focused on creating
                  the best experience possible for every customer. We want our
                  customers and fans to get more out of their daily play than
                  anywhere else. We are constantly exploring new innovative ways
                  to add amazing new features, fun ways to play and most of all,
                  more ways to win.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
